import React, { useState, useEffect } from "react";
import axios from "axios";
import { useAppContext } from "../../AppContext";
import { useTranslation } from "react-i18next";
import { MyDomain } from "../../App";

const DAYS = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];

export default function WorkHoursPage() {
  const [schedule, setSchedule] = useState([]);
  const [loading, setLoading] = useState(true);
  const { AllData } = useAppContext();
  const { t } = useTranslation();

  useEffect(() => {
    const fetchWorkHours = async () => {
      try {
        const response = await axios.get(
          `${MyDomain}WorkHours/${AllData.barberData?.phoneNumber}`,
        );
        const data = response.data;

        const merged = DAYS.map((day) => {
          const found = data.find((d) => d.day === day);
          return (
            found ?? { day, timeStart: null, timeEnd: null, openOrClose: 2 }
          );
        });

        setSchedule(merged);
      } catch (error) {
        console.error("Failed to fetch work hours:", error);
      } finally {
        setLoading(false);
      }
    };

    if (AllData.barberData?.phoneNumber) fetchWorkHours();
  }, [AllData.barberData?.phoneNumber]);

  if (loading) return null;
  if (!schedule.length) return null;

  return (
    <div style={styles.container}>
      {/* Header */}
      <div style={styles.header}>
        <div style={styles.headerLeft}>
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#667eea"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <circle cx="12" cy="12" r="10" />
            <polyline points="12 6 12 12 16 14" />
          </svg>
          <span style={styles.headerTitle}>
            {t("WorkingHours") || "Working Hours"}
          </span>
        </div>
      </div>

      {/* Days List */}
      <div style={styles.list}>
        {schedule.map((item, index) => {
          const isOpen = item.openOrClose === 1;
          const isLast = index === schedule.length - 1;

          return (
            <div
              key={item.day}
              style={{
                ...styles.row,
                borderBottom: isLast ? "none" : "1px solid #f1f5f9",
              }}
            >
              <span
                style={{
                  ...styles.dayName,
                  color: isOpen ? "#0f172a" : "#94a3b8",
                }}
              >
                {t(item.day) || item.day}
              </span>

              {isOpen ? (
                <div style={styles.timeRow}>
                  <span style={styles.timeText}>{item.timeStart}</span>
                  <span style={styles.timeDash}>–</span>
                  <span style={styles.timeText}>{item.timeEnd}</span>
                </div>
              ) : (
                <span style={styles.closedText}>{t("closed") || "Closed"}</span>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}

const styles = {
  container: {
    padding: "20px 16px 8px",
    borderTop: "1px solid #f1f5f9",
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "14px",
  },
  headerLeft: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  headerTitle: {
    fontSize: "16px",
    fontWeight: "700",
    color: "#1a1a1a",
  },
  list: {
    display: "flex",
    flexDirection: "column",
  },
  row: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    paddingTop: "10px",
    paddingBottom: "10px",
  },
  dayName: {
    fontSize: "14px",
    fontWeight: "600",
    flex: 1,
  },
  timeRow: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
  },
  timeText: {
    fontSize: "14px",
    fontWeight: "600",
    color: "#667eea",
  },
  timeDash: {
    fontSize: "14px",
    color: "#94a3b8",
  },
  closedText: {
    fontSize: "13px",
    color: "#94a3b8",
    fontWeight: "500",
  },
};
